import * as React from 'react'
import Svg from '@doordash/component-svg'

type CircleIconProps = {
  size: number
  color: string
}

const CircleIcon = (props: CircleIconProps) => (
  <Svg
      height={props.size}
      width={props.size}
      viewBox={`0 0 ${props.size} ${props.size}`}
  >
      <circle
      cx={props.size / 2}
      cy={props.size / 2}
      r={props.size / 2}
      fill={props.color}
      />
  </Svg>
)

export default CircleIcon 
